import styled, { css } from "styled-components";
import TextProps, { TextType } from "../interface";
import { TextStyleByType } from "../text_style";
import { palette } from "styled-tools";
// ${(props) =>
// 	props.font
// 		? css`
// 				${theme(`typography.${props.font}`)}
// 		  `
// 		: null};

export const Text = styled.div<TextProps>`
  ${(props) => TextStyleByType[props.type as TextType]};
  color: ${(props) =>
    props.color
      ? palette(props.color, props.tone ? props.tone : 0)
      : palette("black")};
  font-weight: ${(props) => (props.bold ? 600 : "")};
  cursor: ${(props) => (props.anchor ? "pointer" : "")};
  line-height: ${(props) => (props.lineHeight ? `${props.lineHeight}px` : "")};
  font-size: ${(props) => (props.size ? `${props.size}px` : "")};
  ${(props) =>
    props.inline &&
    css`
      display: inline-block;
    `};
  text-align: ${(props) => props.align && props.align};
  text-decoration: ${(props) => props.underline && "underline"};
  text-decoration-color: ${(props) =>
    props.underlineColor && palette(props.underlineColor)};

  ${(props) =>
    props.eclipse &&
    css`
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      max-width: ${props.maxWidth && typeof props.maxWidth === "string"
        ? props.maxWidth
        : `${props.maxWidth}px`};
    `};
`;
